
import { useContext, useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { RootStoreContext } from 'stores/root_store';
import useUserIdentity from 'hooks/useUserIdentity';
import useCollaborators from 'hooks/useCollaborators';
import useRoles from 'hooks/useRoles';
import ClaimedWorkList from 'components/ClaimedWorkList';

const CollaboratorsList = observer(( { paged, status, orNull=false }: { paged: boolean, status: string, orNull?: boolean }) => {
    const store = useContext(RootStoreContext).userCollaboratorsStore;
    const { rolesNames } = useRoles();
    const [fetchingSupport, setFetchingSupport] = useState(false);
    const {
        activeCollaborators,
        snoozedCollaborators,
        archivedCollaborators
    } = useCollaborators();
	const { currentIdentity } = useUserIdentity();

    const _getCollabs = (status: string) => {
        if (status === 'active') {
            return activeCollaborators;
        } else if (status === 'snoozed') {
            return snoozedCollaborators;
        } else {
            return archivedCollaborators;
        }
    };

    const collabs = _getCollabs(status)

    /* load the collabs */
    useEffect(() => {
        if (currentIdentity?.uuid && store) {
            store.fetchIdentityCollaborators(currentIdentity.uuid);
        }
    }, [currentIdentity, store]);

    /* load the support collabs if we need to */
    useEffect(() => {
        if(!rolesNames.includes('support'))
            return;
        if(fetchingSupport)
            return;

        setFetchingSupport(true);
        if (currentIdentity?.uuid && store) {
            store.fetchIdentityCollaborators(currentIdentity.uuid, 'support')
                .finally(() => setFetchingSupport(false));
        }
    }, [currentIdentity, rolesNames, store]);

    if (orNull && collabs.length === 0) {
        return null;
    }

    return <ClaimedWorkList paged={paged} status={status} />
});

export default CollaboratorsList;
